import constants from '@core/utils/constants';
import { bus } from '@core/events/eventSystem';
import { serializer } from './serializer';

// List all admins
bus.on(constants.EVENTS.ADMINS.LIST_ALL.REFRESH, () => {
  const requestId = `admins-list-${Date.now()}`;
  bus.emit(constants.EVENTS.ADMINS.LIST_ALL.REFRESHING);
  bus.emit(constants.EVENTS.NETWORK.REQUEST, {
    id: requestId,
    url: constants.ENDPOINTS.ADMINS.GET_LIST,
    method: 'GET',
    data: {}
  });

  bus.on(constants.EVENTS.NETWORK.RESPONSE, (res) => {
    if (res.id === requestId) {
      const parsed = serializer.deserialize(res);
      if (parsed.success) {
        bus.emit(constants.EVENTS.ADMINS.LIST_ALL.REFRESHED, parsed.data);
      } else {
        bus.emit(constants.EVENTS.ADMINS.LIST_ALL.REFRESH_ERROR, parsed.message);
      }
    }
  });
});

// Create admin
bus.on(constants.EVENTS.ADMINS.CREATE_OR_UPDATE.CREATING, (adminData) => {
  const requestId = `admins-create-${Date.now()}`;
  bus.emit(constants.EVENTS.LOADING.START);

  bus.emit(constants.EVENTS.NETWORK.REQUEST, {
    id: requestId,
    url: constants.ENDPOINTS.ADMINS.REGISTER,
    method: 'POST',
    data: serializer.serializeRegister(adminData)
  });

  bus.on(constants.EVENTS.NETWORK.RESPONSE, (res) => {
    if (res.id === requestId) {
      bus.emit(constants.EVENTS.LOADING.FINISH);
      const parsed = serializer.deserializeSingle(res.data || res.error);
      if (parsed.success) {
        bus.emit(constants.EVENTS.TOAST_NOTIFICATION.SHOW, {
          title: 'Succès',
          body: 'Administrateur créé avec succès'
        });
        bus.emit(constants.EVENTS.ADMINS.CREATE_OR_UPDATE.CREATED);
        bus.emit(constants.EVENTS.ADMINS.LIST_ALL.REFRESH);
      } else {
        bus.emit(constants.EVENTS.ADMINS.CREATE_OR_UPDATE.CREATE_ERROR, parsed);
        bus.emit(constants.EVENTS.TOAST_NOTIFICATION.SHOW, {
          title: parsed.errorTitle,
          body: parsed.message
        });
      }
    }
  });
});

// Update admin
bus.on(constants.EVENTS.ADMINS.CREATE_OR_UPDATE.UPDATING, (adminData) => {
  const requestId = `admins-update-${Date.now()}`;
  bus.emit(constants.EVENTS.LOADING.START);

  bus.emit(constants.EVENTS.NETWORK.REQUEST, {
    id: requestId,
    url: constants.ENDPOINTS.ADMINS.UPDATE,
    method: 'POST',
    data: serializer.serializeUpdate(adminData)
  });

  bus.on(constants.EVENTS.NETWORK.RESPONSE, (res) => {
    if (res.id === requestId) {
      bus.emit(constants.EVENTS.LOADING.FINISH);
      const parsed = serializer.deserializeSingle(res.data || res.error);
      if (parsed.success) {
        bus.emit(constants.EVENTS.TOAST_NOTIFICATION.SHOW, {
          title: 'Succès',
          body: 'Administrateur mis à jour avec succès'
        });
        bus.emit(constants.EVENTS.ADMINS.CREATE_OR_UPDATE.UPDATED);
        bus.emit(constants.EVENTS.ADMINS.LIST_ALL.REFRESH);
      } else {
        bus.emit(constants.EVENTS.ADMINS.CREATE_OR_UPDATE.UPDATE_ERROR, parsed);
        bus.emit(constants.EVENTS.TOAST_NOTIFICATION.SHOW, {
          title: parsed.errorTitle,
          body: parsed.message
        });
      }
    }
  });
});

// Delete admin
bus.on(constants.EVENTS.ADMINS.DELETE.DELETING, (adminId) => {
  const requestId = `admins-delete-${Date.now()}`;
  bus.emit(constants.EVENTS.LOADING.START);

  bus.emit(constants.EVENTS.NETWORK.REQUEST, {
    id: requestId,
    url: constants.ENDPOINTS.ADMINS.DELETE,
    method: 'POST',
    data: serializer.serializeDelete(adminId)
  });

  bus.on(constants.EVENTS.NETWORK.RESPONSE, (res) => {
    if (res.id === requestId) {
      bus.emit(constants.EVENTS.LOADING.FINISH);
      const parsed = serializer.deserializeSingle(res.data || res.error);
      if (parsed.success) {
        bus.emit(constants.EVENTS.TOAST_NOTIFICATION.SHOW, {
          title: 'Succès',
          body: 'Administrateur supprimé avec succès'
        });
        bus.emit(constants.EVENTS.ADMINS.DELETE.DELETED);
        bus.emit(constants.EVENTS.ADMINS.LIST_ALL.REFRESH);
      } else {
        bus.emit(constants.EVENTS.ADMINS.DELETE.DELETE_ERROR, parsed);
        bus.emit(constants.EVENTS.TOAST_NOTIFICATION.SHOW, {
          title: parsed.errorTitle,
          body: parsed.message
        });
      }
    }
  });
});
